import { render, staticRenderFns } from "./viewLearningCentreDetails.vue?vue&type=template&id=05a08cd7&"
import script from "./viewLearningCentreDetails.vue?vue&type=script&lang=js&"
export * from "./viewLearningCentreDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewLearningCentreDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports